import React from 'react';
import { Text, Box, RadioGroup } from '@spothero/ui';
import { Controller } from 'react-hook-form';
import BorderedRadio from 'common/bordered-radio';
const cancellationReasons = [
    {
        pk: 327,
        category: 'Customer Issue',
        reason: 'Found cheaper garage/lot parking',
        reasonDisplayedToCustomer: 'Found cheaper garage/lot parking',
        reasonDisplayedToOperator: 'Found cheaper garage/lot parking',
        type: 'customer',
        reservationIsCancellableAfterStart: false,
        reservationCancelAfterStartRequiresProof: false,
        reservationCancelRequiresNoticeWithinThreshold: false,
    },
    {
        pk: 326,
        category: 'Customer Issue',
        reason: 'Found street parking',
        reasonDisplayedToCustomer: 'Found street parking',
        reasonDisplayedToOperator: 'Found street parking',
        type: 'customer',
        reservationIsCancellableAfterStart: false,
        reservationCancelAfterStartRequiresProof: false,
        reservationCancelRequiresNoticeWithinThreshold: false,
    },
    {
        pk: 52,
        category: 'Customer Issue',
        reason: 'No longer need parking',
        reasonDisplayedToCustomer: 'No longer need parking',
        reasonDisplayedToOperator: 'No longer need parking',
        type: 'customer',
        reservationIsCancellableAfterStart: false,
        reservationCancelAfterStartRequiresProof: false,
        reservationCancelRequiresNoticeWithinThreshold: false,
    },
    {
        pk: 329,
        category: 'Operator Issue',
        reason: 'Couldn’t redeem reservation',
        reasonDisplayedToCustomer: 'Couldn’t redeem reservation',
        reasonDisplayedToOperator: 'Couldn’t redeem reservation',
        type: 'customer',
        reservationIsCancellableAfterStart: false,
        reservationCancelAfterStartRequiresProof: false,
        reservationCancelRequiresNoticeWithinThreshold: false,
    },
    {
        pk: 227,
        category: 'Operator Issue',
        reason: 'Lot was full',
        reasonDisplayedToCustomer: 'Lot was full',
        reasonDisplayedToOperator: 'Lot was full',
        type: 'customer',
        reservationIsCancellableAfterStart: false,
        reservationCancelAfterStartRequiresProof: false,
        reservationCancelRequiresNoticeWithinThreshold: false,
    },
    {
        pk: 330,
        category: 'Operator Issue',
        reason: 'Turned away by attendant',
        reasonDisplayedToCustomer: 'Turned away by attendant',
        reasonDisplayedToOperator: 'Turned away by attendant',
        type: 'customer',
        reservationIsCancellableAfterStart: false,
        reservationCancelAfterStartRequiresProof: false,
        reservationCancelRequiresNoticeWithinThreshold: false,
    },
    {
        pk: 328,
        category: 'SpotHero Issue',
        reason: 'Couldn’t find location',
        reasonDisplayedToCustomer: 'Couldn’t find location',
        reasonDisplayedToOperator: 'Couldn’t find location',
        type: 'customer',
        reservationIsCancellableAfterStart: false,
        reservationCancelAfterStartRequiresProof: false,
        reservationCancelRequiresNoticeWithinThreshold: false,
    },
];
const RefundReasons = ({ handleSubmit, control, fieldId, formId, }) => {
    // Cancellation reasons should come from the API, but this API currently doesn't accept an access key so hard coding in the short term
    // const cancellationReasons = useEffect(() => {
    //     return ReservationAPI.getCancellationReasons();
    // }, []);
    return (<Box data-testid="RefundReasons" as="form" sx={{
            '.chakra-form-control': {
                paddingX: 0,
                marginX: 0,
                paddingTop: 0,
            },
            '.chakra-form__label': {
                fontWeight: 'semibold',
                color: 'black',
                fontSize: 'base',
                paddingBottom: 4,
            },
        }} onSubmit={handleSubmit} id={formId}>
            <Controller name={fieldId} control={control} render={({ field }) => (<RadioGroup sx={{
                '.chakra-radio__control': {
                    marginTop: 0.5,
                },
                '.chakra-radio__label': {
                    overflow: 'hidden',
                },
                '.chakra-stack div:not(:first-of-type)': {
                    marginTop: 3,
                },
                '.chakra-form__label': {
                    color: 'black',
                },
            }} marginBottom={4} id={fieldId} label="Why are you cancelling?" {...field}>
                        {cancellationReasons.map(reason => (<BorderedRadio isSelected={field.value === reason.reason} value={reason.reason} radioStyles={{
                    paddingY: 3,
                    height: 'auto',
                }} key={reason.pk}>
                                <Text data-testid="RefundReasons-text-reason">
                                    {reason.reasonDisplayedToCustomer}
                                </Text>
                            </BorderedRadio>))}
                    </RadioGroup>)}/>
        </Box>);
};
export default RefundReasons;
